import { TableContainer, TableHead, TableCell, Typography, TableRow, Table, TableBody, Paper, Box, Button, Radio } from "@mui/material";
import React, { useState, useEffect } from "react";
//firestore
import db from "../firebase/firebase";
import { collection, onSnapshot } from "firebase/firestore";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
//moment
import moment from "moment";
import "moment/locale/fr";
//mui
import { FormControl, RadioGroup, FormControlLabel, FormLabel } from "@mui/material";

const List = () => {
  const [place, setPlace] = useState("Alger");
  const databaseCount = 1441;

  const handleChange = (event) => {
    setPlace(event.target.value);
  };

  const [participants, setParticipants] = useState([]);

  //get all users
  useEffect(() => {
    const unsub = onSnapshot(collection(db, `${place}_${databaseCount}`), (snapshot) => {
      setParticipants(snapshot.docs.map((doc) => doc.data()));
    });

    return unsub;
  }, [place]);

  const downloadExcel = () => {
    const headers = ["#", "Nom", "Prénom", "age", "Email", "Téléphone", "Wilaya", "Date d'inscription"];
    const rows = participants.map((participant, index) => [index + 1, participant.lastName, participant.firstName, participant.age, participant.email, participant.phone, participant.wilaya?.name, participant?.timestamp.toDate()]);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Participants");

    XLSX.writeFile(workbook, "participants.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF();

    const headers = [["#", "Nom", "Prénom", "Age", "Email", "Téléphone", "Wilaya"]];
    const rows = participants.map((participant, index) => [index + 1, participant.lastName, participant.firstName, participant.age, participant.email, participant.phone, participant.wilaya?.name, participant?.timestamp.toDate()]);

    doc.autoTable({
      head: headers,
      body: rows,
    });

    doc.save("participants.pdf");
  };

  const sortedParticipants = participants.sort((a, b) => {
    if (a?.lastName?.toLowerCase() < b?.lastName?.toLowerCase()) return -1;
    if (a?.lastName?.toLowerCase() > b?.lastName?.toLowerCase()) return 1;
    return 0;
  });

  return (
    <Box padding="5px 10px">
      <Box display="flex" gap="32px">
        <Box>
          <Button variant="primary" color="primary" onClick={downloadExcel} sx={{ fontSize: "16px", margin: "1rem 0rem", marginRight: "1rem" }}>
            Télécharger en Excel
          </Button>
          <Button variant="primary" color="secondary" onClick={downloadPDF} sx={{ fontSize: "16px", margin: "1rem 0rem" }}>
            Télécharger en PDF
          </Button>
        </Box>

        <FormControl>
          <FormLabel id="demo-controlled-radio-buttons-group">Localisation :</FormLabel>
          <RadioGroup sx={{ flexDirection: "row" }} aria-labelledby="demo-controlled-radio-buttons-group" name="controlled-radio-buttons-group" value={place} onChange={handleChange}>
            <FormControlLabel value="Alger" control={<Radio />} label="Alger" />
            <FormControlLabel value="Blida" control={<Radio />} label="Blida" />
            <FormControlLabel value="Bab-ezzouar" control={<Radio />} label="Bab-ezzouar" />
            <FormControlLabel value="Enssea" control={<Radio />} label="Enssea" />
            <FormControlLabel value="Oran" control={<Radio />} label="Oran" />
            <FormControlLabel value="Sablette2" control={<Radio />} label="Sablette2" />
            <FormControlLabel value="Zeralda" control={<Radio />} label="Zeralda" />
          </RadioGroup>
        </FormControl>
      </Box>

      <TableContainer component={Paper} sx={{ padding: "32px 10px" }}>
        <Typography variant="h6" gutterBottom>
          Liste des participants
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Nom</TableCell>
              <TableCell>Prénom</TableCell>
              <TableCell>Age</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Téléphone</TableCell>
              <TableCell>Wilaya</TableCell>
              <TableCell>Date et heure d'inscription</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedParticipants.map((participant, index) => (
              <TableRow key={index}>
                <TableCell sx={{ fontWeight: 800 }}>{index + 1}</TableCell>
                <TableCell>{participant?.lastName}</TableCell>
                <TableCell>{participant?.firstName}</TableCell>
                <TableCell>{participant?.age}</TableCell>
                <TableCell>{participant?.email}</TableCell>
                <TableCell>{participant?.phone}</TableCell>
                <TableCell>{participant?.wilaya?.name}</TableCell>
                <TableCell>le {moment(participant?.timestamp?.toDate()).format("DD/MM/YYYY à HH:mm:ss")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default List;
